module.exports = __webpack_public_path__ + "static/assets/a07784032e83fe500c81b64d0585c3b9.png";